import template from './authentication.html';
import controller from './authentication.controller';
import './authentication.styl';

let authenticationComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default authenticationComponent;



// WEBPACK FOOTER //
// ./client/app/components/authentication/authentication.component.js